import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function LockSVG({ classNameProps, height, width }: PropsTypeSvg) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNameProps}
      width={width}
      height={height}
      viewBox='0 0 30 30'
      fill='none'
    >
      <rect
        width='30'
        height='30'
        rx='15'
        className='dark:fill-bg-dark-secondary fill-bg-secondary'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18 14C18.8284 14 19.5 14.6716 19.5 15.5V19.5C19.5 20.3284 18.8284 21 18 21H12C11.1716 21 10.5 20.3284 10.5 19.5V15.5C10.5 14.6716 11.1716 14 12 14L12 12C12 10.3431 13.3431 9 15 9C16.6569 9 18 10.3431 18 12V14ZM13.5 14H16.5V12C16.5 11.1716 15.8284 10.5 15 10.5C14.1716 10.5 13.5 11.1716 13.5 12V14Z'
        className='dark:fill-icon-dark-primary fill-icon-primary'
      />
    </svg>
  );
}

export default LockSVG;
